import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import * as Counter from './Counter';
import * as WeatherForecasts from './WeatherForecasts';
import authReducer from './reducers/authReducer';
import dataReducer from './reducers/dataReducer';

export default function configureStore (history, initialState) {
  const reducers = {
      counter: Counter.reducer,
      weatherForecasts: WeatherForecasts.reducer,
      auth: authReducer,
      data: dataReducer
  };

  const middleware = [
    thunk,
    routerMiddleware(history)
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    routing: routerReducer,
    form
  });

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js